'use strict';

import { createStore } from 'redux';
import { persistStore } from 'redux-persist';
import reducer from '../reducers';

const store = createStore(reducer);

export const persistor = persistStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/helpers/StoreHelper.js